module.exports = __webpack_public_path__ + "static/seo-ifit-d54d15a9994ead56f489ca2cb88966d7.png";